import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
export function MatchDirector() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3494">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3495">
        <div className="mb-12" data-id="element-3496">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-3497">
            Match Director
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3498">
            <p className="text-xl font-bold mb-4" style={{
            color: '#1e3d2f',
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-3499">
              Chris Sorgatz
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-3500">
              <a href="mailto:sorgatz@ameritech.net" className="flex items-center gap-2 px-4 py-2 rounded-lg transition-all hover:opacity-80" style={{
              backgroundColor: 'rgba(30,61,47,0.08)',
              color: '#1e3d2f',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-3501">
                <MailIcon size={16} data-id="element-3502" />
                sorgatz@ameritech.net
              </a>
              <a href="tel:2489536150" className="flex items-center gap-2 px-4 py-2 rounded-lg transition-all hover:opacity-80" style={{
              backgroundColor: 'rgba(30,61,47,0.08)',
              color: '#1e3d2f',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-3503">
                <PhoneIcon size={16} data-id="element-3504" />
                248.953.6150
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
}